<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">EC画像指示一覧表</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">出力区分</label>
          <div class="list-input-content">
            <app-radio-label label="画像指示一覧表" name="rbtg_radiogroup" id="rbtn_UseFile" #rbtn_UseFile
              [subid]="'rbtn_UseFile'" value="1" [tabindex]="0" [(ngModel)]="kymw6100Model.radioGroup"
              [forcedEnabledMode]="'true'" [autofocus]="true" (change)="eventImageFile_enabled()">
            </app-radio-label>
            <app-radio-label label="画像ファイル" name="rbtg_radiogroup" id="rbtn_ImageFile"
              #rbtn_ImageFile [subid]="'rbtn_ImageFile'" value="2" [tabindex]="0" [(ngModel)]="kymw6100Model.radioGroup"
              [forcedEnabledMode]="'true'" (change)="eventImageFile_enabled()">
            </app-radio-label>
          </div>

          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
              [catalogIDField]="lbl_CatalogId" [forcedEnabledMode]="'none'" [tabindex]="0"
              [(ngModel)]="kymw6100Model.orderCode">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
          </div>

          <label class="list-input-title">画像ファイル名リスト</label>
          <div class="list-input-content">
            <div class="element-column">
              <textarea style="height:200px; width: 372px;" id="txta_FileNameList" #txta_FileNameList forcedEnabledMode="none"
                plessInputTextSub [restrict]="'[ -￮\n]'" wordWrap="true" [tabindex]="0"
                [(ngModel)]="kymw6100Model.fileNameList"></textarea>
              <label>・１行１件の画像ファイル名を入力してください。</label>
              <label>・一度に入力できる画像ファイル名は500件までとします。</label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventCSVOut_CLICKHandler()">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>